import { cn } from '@shared/utils';
import { ColumnsType } from '../table';

interface CurrentRowType {
  value: string;
  more?: boolean;
}

interface MobileFullViewProps {
  data: CurrentRowType[];
  columns: ColumnsType[];
  handleClose: () => void;
}

export const MobileFullView = (props: MobileFullViewProps) => {
  return (
    <div>
      <div className='fixed top-0 right-0 bottom-0 left-0 z-[1500] bg-black' />
      <div className='fixed top-2.5 right-2.5 bottom-2.5 left-2.5 z-[1500] rounded bg-[#efefef] pt-2.5 pb-5 shadow-[6px_6px_12px_0_#0000000a]'>
        <div className='absolute top-5 right-4 h-4 w-4' onClick={props.handleClose}>
          <svg width='17' height='17' viewBox='0 0 17 17' xmlns='http://www.w3.org/2000/svg'>
            <g fill='#343434'>
              <path d='M.519 15.073l15.053-15.053 1.32 1.32-15.053 15.053zM1.828.008l15.053 15.053-1.32 1.32-15.053-15.053z' />
            </g>
          </svg>
        </div>
        <div className='flex h-full flex-col items-start justify-start'>
          {props.data.map((cell, idx) =>
            cell != null && typeof cell === 'object' ? (
              <div
                key={idx}
                className={cn(
                  'mx-9 flex w-[calc(100%-72px)] flex-col border-t border-t-gray-300 py-5',
                  'first:border-t-0',
                  cell.more && 'mx-0 w-full items-center border-t py-1',
                )}
              >
                {!cell.more && (
                  <div className='mt-2.5 mb-1 text-sm font-semibold text-[#191919] uppercase'>
                    {props.columns.filter((_, idx) => idx === idx).map((column) => column.title)}
                  </div>
                )}
                <div className={cn('text-sm font-medium text-[#343434]')}>{cell.value ? cell.value : '--'}</div>
              </div>
            ) : null,
          )}
        </div>
      </div>
    </div>
  );
};
